export default "__VITE_ASSET__5de81ece__"